import { IBaseResponse } from "./IBaseResponse";
import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IExpenseCreate } from "../interfaces/Expense/IExpenseCreate";
import { IChangeExpenseStatusRequest } from "../interfaces/Expense/IChangeExpenseStatusRequest";
import { IExpenseUpdate } from "../interfaces/Expense/IExpenseUpdate";
import { IExpenseDetail } from "../interfaces/Expense/IExpenseDetail";
import { IFileToUpload } from "../interfaces/IFileToUpload";
import { IExpenseTradeItemCreate } from "../interfaces/Expense/IExpenseTradeItemCreate";

enum ExpenseRequestServiceEnum {
  getReason = "/get-reason/",
  getTrades = "/get-trades",
  putApproveStatus = "/approve",
  putReturnStatus = "/return",
  postCreate = "/",
  putUpdate = "/",
  loadExpenseFromExcel="/load-expense-from-excel"
}

export class ExpenseRequestService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/expense");
  }

  public getReason = async (expenseId: number): Promise<IBaseResponse> => await this.GET(ExpenseRequestServiceEnum.getReason + expenseId);
  public getTrades = async (): Promise<number[]> => await this.GET(ExpenseRequestServiceEnum.getTrades);

  public postCreate = async (expense: IExpenseCreate): Promise<IBaseResponse<IExpenseDetail[]>> => await this.POST(ExpenseRequestServiceEnum.postCreate, expense);
  public putUpdate = async (expense: IExpenseUpdate): Promise<IBaseResponse> => await this.PUT(ExpenseRequestServiceEnum.postCreate, expense);
  public putApproveStatus = async (data: IChangeExpenseStatusRequest): Promise<IBaseResponse> => await this.PUT(ExpenseRequestServiceEnum.putApproveStatus, data);
  public putReturnStatus = async (data: IChangeExpenseStatusRequest): Promise<IBaseResponse> => await this.PUT(ExpenseRequestServiceEnum.putReturnStatus, data);

  public loadExpenseFromExcel = async (data: Omit<IFileToUpload, "id" | "path">): Promise<IExpenseTradeItemCreate[]> => await this.PUT(ExpenseRequestServiceEnum.loadExpenseFromExcel, data);
}



// WEBPACK FOOTER //
// ./src/services/api/ExpenseRequest.service.ts